const prefix = 'login'
export const LOGIN_REQUST = `${prefix}/request`
export const LOGIN_RESPONSE = `${prefix}/response`
export const LOGIN_REDIRECT = `${prefix}/redirect`
export const RESTORE_LOGIN = `${prefix}/restore`
export const LOGOUT = `${prefix}/logout`

export function loginRequest(username, password) {
  return {
    type: LOGIN_REQUST,
    payload: {
      username, password
    }
  }
}

export function loginResponse(userDocument) {
  return {
    type: LOGIN_RESPONSE,
    payload: {
      userDocument
    }
  }
}

export function restoreLogin() {
  return {
    type: RESTORE_LOGIN,
    payload: {
    }
  }
}

export function logout() {
  return {
    type: LOGOUT,
    payload: {
    }
  }
}
